import { useSearchParams } from 'react-router';

export type Pestanas = readonly (readonly [string, string])[];

/** Pestaña activa en `?tab=` (la primera si no hay o no existe). */
export function usePestana<P extends Pestanas>(pestanas: P) {
  const [params, setParams] = useSearchParams();
  const actual = params.get('tab');
  const pestana = (
    pestanas.some(([k]) => k === actual) ? actual : pestanas[0]?.[0]
  ) as P[number][0];
  const cambiar = (k: P[number][0]) => {
    const p = new URLSearchParams(params);
    if (k === pestanas[0]?.[0]) p.delete('tab');
    else p.set('tab', k);
    setParams(p, { replace: true });
  };
  return [pestana, cambiar] as const;
}
